import { configureStore } from "@reduxjs/toolkit";
import { productReducer } from "./slices/productReducer";
import { appReducer } from "./slices/appSlice";
import { authReducer } from "./slices/authSlice";
import { stockReducer } from "./slices/stockSlice";
import { notificationReducer } from "./slices/notificationSlice";

const store = configureStore({
  reducer: {
    app: appReducer,
    product: productReducer,
    auth: authReducer,
    stock: stockReducer,
    notification: notificationReducer,
  },
});
export default store;

// Types for TypeScript
export type RootState = ReturnType<typeof store.getState>;
